import { useTranslation } from 'react-i18next';
import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { StatementsInvoiceSection } from '../../components/statements-invoice.components';
import { useState } from 'react';

function StatementsPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='statements-invoice'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='px-3 mb-0'>
                        <h3 className="dashboard-page__title mb-0">{t('STATEMENTS_LABEL')}</h3>
                        <p className='pb-4 my-0'>{t('STATEMENTS_DESCRIPTION')}</p>
                        <StatementsInvoiceSection
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default StatementsPage;
